// TMOS Template CRUD Service Wrapper
// Date: January 26, 2025
// Purpose: Wrapper service for template management compatible with FlexibleCRUDTable

import { templateService, Template } from './templateService';

export class TemplateCRUDService {
  // Get all templates with optional filters (for FlexibleCRUDTable compatibility)
  async getAll(params: any = {}): Promise<{ data: Template[], pagination?: any }> {
    // Extract filters from params and pass them to getTemplates
    const { page, limit, search, ...filters } = params;
    const templates = await templateService.getTemplates(filters);
    
            
    // Apply search filter if provided
    let filteredTemplates = templates;
    if (search) {
      filteredTemplates = templates.filter(template => 
        template.name.toLowerCase().includes(search.toLowerCase()) ||
        (template.description && template.description.toLowerCase().includes(search.toLowerCase()))
      );
    }
    
        
    return {
      data: filteredTemplates,
      pagination: {
        currentPage: page || 1,
        totalPages: 1,
        totalItems: filteredTemplates.length,
        itemsPerPage: limit || filteredTemplates.length
      }
    };
  }

  // Get all templates with optional filters
  async findAll(filters: any = {}): Promise<Template[]> {
    return await templateService.getTemplates(filters);
  }

  // Get a single template by ID
  async findById(id: string): Promise<Template> {
    return await templateService.getTemplate(id);
  }

  // Create a new template
  async create(data: any): Promise<Template> {
    return await templateService.createTemplate(data);
  }

  // Update an existing template
  async update(id: string, data: any): Promise<Template> {
    return await templateService.updateTemplate(id, data);
  }

  // Delete a template
  async delete(id: string): Promise<void> {
    return await templateService.deleteTemplate(id);
  }

  // Get template count (for pagination)
  async count(filters: any = {}): Promise<number> {
    const templates = await templateService.getTemplates(filters);
    return templates.length;
  }

  // Search templates
  async search(searchTerm: string, filters: any = {}): Promise<Template[]> {
    const searchFilters = {
      ...filters,
      search: searchTerm
    };
    return await templateService.getTemplates(searchFilters);
  }
}

export const templateCRUDService = new TemplateCRUDService();
